import { render, staticRenderFns } from "./HistoryApprovalEpcs.vue?vue&type=template&id=bde83bc6&scoped=true&"
import script from "./HistoryApprovalEpcs.vue?vue&type=script&lang=js&"
export * from "./HistoryApprovalEpcs.vue?vue&type=script&lang=js&"
import style0 from "./HistoryApprovalEpcs.vue?vue&type=style&index=0&id=bde83bc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde83bc6",
  null
  
)

export default component.exports